'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Container = require('./components/Container.IFrame');

var _Container2 = _interopRequireDefault(_Container);

var _Content = require('./components/Content.IFrame');

var _Content2 = _interopRequireDefault(_Content);

var _Bar = require('./components/Bar.IFrame');

var _Bar2 = _interopRequireDefault(_Bar);

var _FrameContainer = require('./components/FrameContainer.IFrame');

var _FrameContainer2 = _interopRequireDefault(_FrameContainer);

var _Frame = require('./components/Frame.IFrame');

var _Frame2 = _interopRequireDefault(_Frame);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var IFrame = function IFrame(_ref) {
  var visible = _ref.visible,
      src = _ref.src,
      onClose = _ref.onClose;
  return _react2.default.createElement(_Container2.default, {
    visible: visible
  }, _react2.default.createElement(_Content2.default, null, _react2.default.createElement(_Bar2.default, {
    src: src,
    onClose: onClose
  }), _react2.default.createElement(_FrameContainer2.default, null, !!src && _react2.default.createElement(_Frame2.default, {
    src: src
  }))));
}; // Components


IFrame.propTypes = {
  visible: _propTypes2.default.bool,
  src: _propTypes2.default.string,
  onClose: _propTypes2.default.func
};
exports.default = IFrame;